module.exports = __webpack_public_path__ + "static/media/Pdf.88355b3e.svg";